// منوی اپ کارکنان (AP-008): آرایه { id، labelKey، path، icon، permission?، feature? } به ازای ماژول.
// آیتم بدون Permission پنهان؛ Feature غیرفعال ← UpgradeBadge و لینک اشتراک (AC-PLT-031.2).
// Promptهای UI هر ماژول آیتم خود را اینجا اضافه و placeholder را با صفحه واقعی جایگزین می‌کنند.
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';
import AutoModeOutlinedIcon from '@mui/icons-material/AutoModeOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import HourglassBottomOutlinedIcon from '@mui/icons-material/HourglassBottomOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import VaccinesOutlinedIcon from '@mui/icons-material/VaccinesOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ApiOutlinedIcon from '@mui/icons-material/ApiOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import TabletAndroidOutlinedIcon from '@mui/icons-material/TabletAndroidOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import CableOutlinedIcon from '@mui/icons-material/CableOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CardMembershipOutlinedIcon from '@mui/icons-material/CardMembershipOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import VideoCameraFrontOutlinedIcon from '@mui/icons-material/VideoCameraFrontOutlined';
import DuoOutlinedIcon from '@mui/icons-material/DuoOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import RuleFolderOutlinedIcon from '@mui/icons-material/RuleFolderOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import TrendingDownOutlinedIcon from '@mui/icons-material/TrendingDownOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import DynamicFormOutlinedIcon from '@mui/icons-material/DynamicFormOutlined';
import DrawOutlinedIcon from '@mui/icons-material/DrawOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import LockClockOutlinedIcon from '@mui/icons-material/LockClockOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import SyncProblemOutlinedIcon from '@mui/icons-material/SyncProblemOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import DeviceHubOutlinedIcon from '@mui/icons-material/DeviceHubOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import DevicesOtherOutlinedIcon from '@mui/icons-material/DevicesOtherOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import SensorsOutlinedIcon from '@mui/icons-material/SensorsOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import MedicationOutlinedIcon from '@mui/icons-material/MedicationOutlined';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import WebOutlinedIcon from '@mui/icons-material/WebOutlined';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import type { MenuItemDefinition } from '@phoenix/ui';

/** صفحه اشتراک (SCR-STAFF-904) — مقصد همه نشان‌های «نیازمند ارتقا». */
export const SUBSCRIPTION_PATH = '/settings/subscription';

export interface StaffMenuItem extends MenuItemDefinition {
  /** شناسه صفحه مقصد (SCR-...) برای placeholder تا Prompt UI ماژول. */
  screenId?: string;
  children?: readonly StaffMenuItem[];
}

export const staffMenu: readonly StaffMenuItem[] = [
  { id: 'home', labelKey: 'shell:menu.home', path: '/', icon: HomeOutlinedIcon },
  // AP-CLN-01: میز کار ارائه‌دهنده و کارهای معوق (IA §2.2 Physician/Therapist/Psychologist/Nurse؛ §2.3 /desk)؛ مواجهه /desk/encounters/:id در routes.tsx.
  {
    id: 'desk',
    labelKey: 'cln:menu.desk',
    path: '/desk',
    icon: MonitorHeartOutlinedIcon,
    permission: 'cln.record.view',
    screenId: 'SCR-STAFF-500',
  },
  {
    id: 'clinical-pending',
    labelKey: 'cln:menu.pending',
    path: '/desk/pending',
    icon: ChecklistOutlinedIcon,
    permission: 'cln.record.view',
    screenId: 'SCR-STAFF-506',
  },
  {
    id: 'clinical-reminders',
    labelKey: 'cln:reminders.menu',
    path: '/desk/reminders',
    icon: ChecklistOutlinedIcon,
    permission: 'cln.reminder.manage',
    screenId: 'SCR-STAFF-517',
  },
  // AP-CLN-02: گزارش عوارض (SCR-STAFF-507)؛ طرح درمان /desk/plans/:id در routes.tsx.
  {
    id: 'clinical-adverse',
    labelKey: 'cln:menu.adverse',
    path: '/desk/adverse-events',
    icon: ReportProblemOutlinedIcon,
    permission: 'cln.adverse_event.report',
    screenId: 'SCR-STAFF-507',
  },
  // AP-MED-01: درخواست‌ها و نتایج (SCR-STAFF-702) و ارجاع‌ها (SCR-STAFF-705)؛ ویرایشگرهای نسخه، درخواست و ارجاع در مواجهه.
  {
    id: 'med-orders',
    labelKey: 'med:menu.orders',
    path: '/desk/orders',
    icon: ScienceOutlinedIcon,
    anyPermission: ['med.result.review', 'med.order.create', 'med.result.enter', 'med.order.track'],
    screenId: 'SCR-STAFF-702',
  },
  {
    id: 'med-referrals',
    labelKey: 'med:menu.referrals',
    path: '/desk/referrals',
    icon: ForwardToInboxOutlinedIcon,
    anyPermission: ['med.referral.respond', 'med.referral.schedule'],
    screenId: 'SCR-STAFF-705',
  },
  // AP-MED-02: صف خطای ارسال ملی (SCR-STAFF-701؛ US-MED-034) — نمای عملیاتی بدون محتوای بالینی، پس پذیرش هم آن را می‌بیند.
  {
    id: 'med-national-queue',
    labelKey: 'med:menu.national_queue',
    path: '/desk/national-submissions',
    icon: CloudSyncOutlinedIcon,
    permission: 'med.national_submission.manage',
    screenId: 'SCR-STAFF-701',
  },
  // AP-MED-03: ارجاع ملی و کدهای رهگیری مواجهه (SCR-STAFF-707؛ US-MED-070، 072، 076). نمای کد رهگیری عملیاتی است،
  // پس پذیرش هم آن را می‌بیند؛ ثبت و استعلام تنها با `med.national_referral.submit` دیده می‌شوند.
  {
    id: 'med-national-referrals',
    labelKey: 'med:menu.national_referrals',
    path: '/desk/national-referrals',
    icon: ForwardToInboxOutlinedIcon,
    anyPermission: ['med.national_referral.track', 'med.national_referral.submit'],
    screenId: 'SCR-STAFF-707',
  },
  // AP-MED-04 (US-MED-086): پایش همه ارسال‌های ملی؛ نمای عملیاتی بدون اقلام، پس پذیرش هم آن را می‌بیند (BR-MED-087).
  {
    id: 'med-rx-monitor',
    labelKey: 'med:menu.rx_monitor',
    path: '/desk/rx-monitor',
    icon: CloudSyncOutlinedIcon,
    permission: 'med.rx_monitor.view',
    screenId: 'SCR-STAFF-710',
  },
  // AP-MED-04 (US-MED-088؛ US-CLN-160): ویزیت فشرده «فقط نسخه».
  {
    id: 'med-rx-only-visit',
    labelKey: 'med:menu.rx_only_visit',
    path: '/desk/rx-only-visit',
    icon: LocalHospitalOutlinedIcon,
    permission: 'med.prescription.create',
    screenId: 'SCR-STAFF-711',
  },
  // AP-MED-05 (US-MED-096): کارتابل پرستاری تامین؛ فقط با نشست تامین خود پرستار و از شعبه دارای سیام.
  {
    id: 'med-nursing-cartable',
    labelKey: 'med:menu.nursing_cartable',
    path: '/desk/nursing-cartable',
    icon: VaccinesOutlinedIcon,
    permission: 'med.nursing_order.perform',
    screenId: 'SCR-STAFF-715',
  },
  // AP-MED-04 (US-MED-089): پیگیری پیش‌نویس‌های ارسالی تهیه‌کننده.
  {
    id: 'med-approvals-mine',
    labelKey: 'med:menu.approvals_mine',
    path: '/desk/approvals/mine',
    icon: ForwardToInboxOutlinedIcon,
    permission: 'med.prescription.request_approval',
    screenId: 'SCR-STAFF-712',
  },
  // AP-MED-04 (US-MED-090): صندوق تأیید از راه دور استاد (موبایل‌محور، همان PWA).
  {
    id: 'med-approvals-inbox',
    labelKey: 'med:menu.approvals_inbox',
    path: '/desk/approvals/inbox',
    icon: ForwardToInboxOutlinedIcon,
    permission: 'med.prescription.approve_remote',
    screenId: 'SCR-STAFF-714',
  },
  // AP-MED-03: دستورهای بستری تامین با نشست خودِ کاربر (SCR-STAFF-716؛ US-MED-098).
  {
    id: 'med-insurer-admissions',
    labelKey: 'med:menu.insurer_admissions',
    path: '/desk/insurer-admission-orders',
    icon: LocalHospitalOutlinedIcon,
    permission: 'med.inpatient_order.view',
    screenId: 'SCR-STAFF-716',
  },
  // AP-INT-05: صف «نتایج نامعلوم» (SCR-STAFF-703؛ US-MED-051) — تطبیق دستی پیام نتیجه با پرونده.
  {
    id: 'med-inbound-lab',
    labelKey: 'med:menu.inbound_lab',
    path: '/desk/inbound-lab-messages',
    icon: RuleOutlinedIcon,
    permission: 'med.result.enter',
    screenId: 'SCR-STAFF-703',
  },
  // AP-SCH-01: برگه روز پذیرش و تقویم (IA §2.2، §2.3)؛ جزئیات نوبت /appointments/:id در routes.tsx.
  {
    id: 'today',
    labelKey: 'sch:menu.today',
    path: '/today',
    icon: TodayOutlinedIcon,
    permission: 'sch.appointment.view',
    screenId: 'SCR-STAFF-301',
  },
  {
    id: 'calendar',
    labelKey: 'sch:menu.calendar',
    path: '/calendar',
    icon: CalendarMonthOutlinedIcon,
    permission: 'sch.appointment.view',
    screenId: 'SCR-STAFF-300',
  },
  {
    id: 'bulk-closures',
    labelKey: 'sch:menu.bulk_closures',
    path: '/bulk-closures',
    icon: EventBusyOutlinedIcon,
    permission: 'sch.schedule.manage',
    screenId: 'SCR-STAFF-314',
  },
  // AP-ORG-02: وضعیت لحظه‌ای منابع برای پذیرش (US-ORG-022). دستورکارها در گروه تجهیزات، بعد از همین بلوک نوبت‌دهی‌اند.
  {
    id: 'resource-status',
    labelKey: 'org:menu.resource_status',
    path: '/resources',
    icon: SensorsOutlinedIcon,
    permission: 'org.resource.view',
    screenId: 'SCR-STAFF-934',
  },
  // AP-SCH-02: صف جابه‌جایی، لیست انتظار، برنامه من (فهرست امروز ارائه‌دهنده) و گزارش نوبت‌دهی (IA §2.2).
  {
    id: 'reschedule-queue',
    labelKey: 'sch:menu.reschedule_queue',
    path: '/reschedule-queue',
    icon: EventRepeatOutlinedIcon,
    permission: 'sch.reschedule_queue.manage',
    screenId: 'SCR-STAFF-305',
  },
  {
    id: 'waitlist',
    labelKey: 'sch:menu.waitlist',
    path: '/waitlist',
    icon: HourglassTopOutlinedIcon,
    permission: 'sch.waitlist.manage',
    screenId: 'SCR-STAFF-306',
  },
  // AP-CHN-01 (US-SCH-026): صف تأیید رزروهای آنلاین پرتال و ویجت (C-AGENT-1404: همان sch.appointment.update).
  {
    id: 'online-requests',
    labelKey: 'sch:menu.online_requests',
    path: '/online-requests',
    icon: EventAvailableOutlinedIcon,
    permission: 'sch.appointment.update',
    screenId: 'SCR-STAFF-307',
  },
  // AP-CLN-03 (US-SCH-013): جلسات گروهی با ظرفیت و لیست انتظار جلسه.
  {
    id: 'group-sessions',
    labelKey: 'sch:menu.group_sessions',
    path: '/group-sessions',
    icon: GroupsOutlinedIcon,
    permission: 'sch.appointment.view',
    screenId: 'SCR-STAFF-302',
  },
  {
    id: 'my-schedule',
    labelKey: 'sch:menu.my_schedule',
    path: '/my-schedule',
    icon: AssignmentIndOutlinedIcon,
    permission: 'sch.schedule.view_own',
    screenId: 'SCR-STAFF-304',
  },
  {
    id: 'appointment-report',
    labelKey: 'sch:menu.report',
    path: '/reports/appointments',
    icon: InsertChartOutlinedIcon,
    permission: 'sch.report.view',
    screenId: 'SCR-STAFF-312',
  },
    // AP-PAT-01: فهرست و جستجوی مراجعه‌کنندگان (IA §2.3)؛ پرونده /patients/:id در routes.tsx.
  {
    id: 'patients',
    labelKey: 'pat:menu.patients',
    path: '/patients',
    icon: PeopleAltOutlinedIcon,
    permission: 'pat.patient.view',
    screenId: 'SCR-STAFF-100',
  },
  // AP-BIL-01: مراجعه‌های باز و صورتحساب‌ها (IA §2.2)؛ مراجعه /visits/:id و صورتحساب /invoices/:id در routes.tsx.
  {
    id: 'visits',
    labelKey: 'bil:menu.visits',
    path: '/visits',
    icon: PointOfSaleOutlinedIcon,
    permission: 'bil.visit.view',
    screenId: 'SCR-STAFF-400',
  },
  {
    id: 'invoices',
    labelKey: 'bil:menu.invoices',
    path: '/invoices',
    icon: ReceiptLongOutlinedIcon,
    permission: 'bil.visit.view',
    screenId: 'SCR-STAFF-403',
  },
  // AP-BIL-02: صندوق، شیفت، استردادها، بیعانه‌ها و گزارش صندوق (IA §2.2 نقش Cashier)؛ تسویه مراجعه /cashier/checkout/:visitId و پروفایل مالی
  // /patients/:id/billing در routes.tsx.
  {
    id: 'cashier',
    labelKey: 'bil:menu.cashier',
    path: '/cashier',
    icon: PaymentsOutlinedIcon,
    permission: 'bil.payment.receive',
    screenId: 'SCR-STAFF-401',
  },
  {
    id: 'cash-session',
    labelKey: 'bil:menu.session',
    path: '/cashier/session',
    icon: LockClockOutlinedIcon,
    anyPermission: ['bil.cash_session.open', 'bil.cash_session.view_all'],
    screenId: 'SCR-STAFF-402',
  },
  {
    id: 'refunds',
    labelKey: 'bil:menu.refunds',
    path: '/refunds',
    icon: ReplayOutlinedIcon,
    anyPermission: ['bil.refund.create', 'bil.refund.approve'],
    screenId: 'SCR-STAFF-404',
  },
  {
    id: 'deposits',
    labelKey: 'bil:menu.deposits',
    path: '/deposits',
    icon: SavingsOutlinedIcon,
    permission: 'bil.visit.view',
    screenId: 'SCR-STAFF-405',
  },
  {
    id: 'cash-report',
    labelKey: 'bil:menu.report',
    path: '/reports/cash',
    icon: AssessmentOutlinedIcon,
    permission: 'bil.report.view',
    screenId: 'SCR-STAFF-414',
  },
  // AP-OFF-01 (ADR-011، ARD-offline): میز آفلاین پذیرش و صندوق و صف بررسی همگام‌سازی (C-AGENT-1550).
  {
    id: 'offline-desk',
    labelKey: 'bil:menu.offline_desk',
    path: '/offline',
    icon: CloudOffOutlinedIcon,
    anyPermission: ['sch.appointment.checkin', 'pat.patient.create', 'bil.payment.receive'],
    screenId: 'SCR-STAFF-417',
  },
  {
    id: 'sync-conflicts',
    labelKey: 'bil:menu.sync_conflicts',
    path: '/offline/conflicts',
    icon: SyncProblemOutlinedIcon,
    permission: 'bil.sync_conflict.manage',
    screenId: 'SCR-STAFF-418',
  },
  // AP-BIL-03: فروش و مدیریت پکیج، برآورد هزینه و گزارش پیش‌دریافت (IA §2.2 نقش SalesConsultant و Cashier)؛ /quotes/new و /quotes/:id در routes.tsx.
  {
    id: 'package-sales',
    labelKey: 'bil:menu.packages',
    path: '/packages',
    icon: CardGiftcardOutlinedIcon,
    permission: 'bil.visit.view',
    screenId: 'SCR-STAFF-406',
  },
  {
    id: 'quotes',
    labelKey: 'bil:menu.quotes',
    path: '/quotes',
    icon: RequestQuoteOutlinedIcon,
    permission: 'bil.visit.view',
    screenId: 'SCR-STAFF-407',
  },
  {
    id: 'deferred-revenue',
    labelKey: 'bil:menu.deferred',
    path: '/reports/deferred-revenue',
    icon: HourglassBottomOutlinedIcon,
    permission: 'bil.report.view',
    screenId: 'SCR-STAFF-414',
  },
  // AP-BIL-04: اقساط و معوقات، چک‌ها، مغایرت‌گیری PSP، فروش کالا (صندوق سریع) و گزارش مطالبات.
  {
    id: 'installments',
    labelKey: 'bil:menu.installments',
    path: '/installments',
    icon: EventRepeatOutlinedIcon,
    permission: 'bil.visit.view',
    screenId: 'SCR-STAFF-409',
  },
  {
    id: 'cheques',
    labelKey: 'bil:menu.cheques',
    path: '/cheques',
    icon: CreditScoreOutlinedIcon,
    permission: 'bil.cheque.manage',
    screenId: 'SCR-STAFF-410',
  },
  {
    id: 'reconciliation',
    labelKey: 'bil:menu.reconciliation',
    path: '/reconciliation',
    icon: CompareArrowsOutlinedIcon,
    permission: 'bil.psp.reconcile',
    screenId: 'SCR-STAFF-412',
  },
  {
    id: 'product-sale',
    labelKey: 'bil:menu.product_sale',
    path: '/cashier/products',
    icon: ShoppingCartOutlinedIcon,
    permission: 'bil.payment.receive',
    feature: 'feature.inv.inventory',
    screenId: 'SCR-STAFF-413',
  },
  {
    id: 'receivables',
    labelKey: 'bil:menu.receivables',
    path: '/reports/receivables',
    icon: TrendingDownOutlinedIcon,
    permission: 'bil.report.view',
    screenId: 'SCR-STAFF-414',
  },
  // AP-BIL-05: صف صورتحساب‌های الکترونیک ناموفق (SCR-STAFF-416؛ US-BIL-023) و حساب سازمان‌ها (SCR-STAFF-411).
  {
    id: 'bil-e-invoices',
    labelKey: 'bil:menu.e_invoices',
    path: '/reports/e-invoices',
    icon: ReceiptLongOutlinedIcon,
    permission: 'bil.report.view',
    screenId: 'SCR-STAFF-416',
  },
  {
    id: 'bil-organization-accounts',
    labelKey: 'bil:menu.organization_accounts',
    path: '/organization-accounts',
    icon: BusinessOutlinedIcon,
    permission: 'bil.org_account.manage',
    screenId: 'SCR-STAFF-411',
  },
  // AP-IAM-03: صف تأییدهای عملیات بیش از سقف (خودخدمت؛ مجوز تصمیم با سقف — C-AGENT-387).
  {
    id: 'approvals',
    labelKey: 'iam:menu.approvals',
    path: '/approvals',
    icon: FactCheckOutlinedIcon,
    screenId: 'SCR-STAFF-404',
  },
  // AP-ORG-03: گروه «تجهیزات» بعد از عملیات روزانهٔ نوبت‌دهی، نه وسط آن (دستورکارها SCR-STAFF-937 و داشبورد SCR-STAFF-938).
  {
    id: 'equipment',
    labelKey: 'org:menu.equipment',
    path: '/equipment',
    children: [
      {
        id: 'work-orders',
        labelKey: 'org:menu.work_orders',
        path: '/work-orders',
        icon: BuildOutlinedIcon,
        permission: 'org.work_order.manage',
        feature: 'feature.org.devices',
        screenId: 'SCR-STAFF-937',
      },
      {
        id: 'equipment-dashboard',
        labelKey: 'org:menu.equipment_dashboard',
        path: '/equipment/dashboard',
        icon: InsertChartOutlinedIcon,
        permission: 'org.device.report.view',
        feature: 'feature.org.devices',
        screenId: 'SCR-STAFF-938',
      },
    ],
  },
  // AP-TEL-01: ویزیت آنلاین — پایش اتاق انتظار و تنظیمات جلسه (SCR-STAFF-980، 982؛ پنل جلسه خودش در میز کار است).
  {
    id: 'telehealth',
    labelKey: 'tel:menu.telehealth',
    path: '/telehealth',
    children: [
      {
        id: 'tel-waiting-room',
        labelKey: 'tel:menu.waiting_room',
        path: '/telehealth/waiting-room',
        icon: DuoOutlinedIcon,
        permission: 'tel.session.monitor',
        feature: 'feature.tel.virtual_visits',
        screenId: 'SCR-STAFF-980',
      },
      {
        id: 'tel-settings',
        labelKey: 'tel:menu.settings',
        path: '/telehealth/settings',
        icon: VideoCameraFrontOutlinedIcon,
        permission: 'tel.settings.manage',
        feature: 'feature.tel.virtual_visits',
        screenId: 'SCR-STAFF-982',
      },
    ],
  },
  // AP-MSG-01: پیام‌های ورودی، لاگ پیام و اطلاعیه گروهی (IA §2.3).
  {
    id: 'messages',
    labelKey: 'msg:menu.messages',
    path: '/messages',
    children: [
      {
        id: 'inbound-messages',
        labelKey: 'msg:menu.inbound',
        path: '/messages/inbound',
        icon: MoveToInboxOutlinedIcon,
        permission: 'msg.inbound.manage',
        screenId: 'SCR-STAFF-953',
      },
      {
        id: 'message-log',
        labelKey: 'msg:menu.log',
        path: '/messages/log',
        icon: ListAltOutlinedIcon,
        permission: 'msg.log.view',
        screenId: 'SCR-STAFF-954',
      },
      {
        id: 'bulk-notices',
        labelKey: 'msg:menu.bulk',
        path: '/messages/bulk-notices',
        icon: CampaignOutlinedIcon,
        permission: 'msg.send.bulk_notice',
        screenId: 'SCR-STAFF-955',
      },
    ],
  },
  // AP-ACC-01: حسابداری (IA §1 Accountant: «حسابداری»؛ SCR-STAFF-880 تا 891).
  {
    id: 'accounting',
    labelKey: 'acc:menu.accounting',
    path: '/accounting',
    children: [
      {
        id: 'acc-journals',
        labelKey: 'acc:menu.journals',
        path: '/accounting/journals',
        icon: MenuBookOutlinedIcon,
        permission: 'acc.journal.view',
        screenId: 'SCR-STAFF-882',
      },
      {
        // AP-ACC-03 (US-ACC-021، 023): کارتابل سند دستی و تأیید؛ تأییدکننده هم بی مجوز ساخت، صف خودش را می‌بیند.
        id: 'acc-manual-journals',
        labelKey: 'acc:menu.manual_journals',
        path: '/accounting/manual-journals',
        icon: EditNoteOutlinedIcon,
        anyPermission: ['acc.journal.manual.create', 'acc.journal.approve'],
        feature: 'feature.acc.full_ledger',
        screenId: 'SCR-STAFF-882',
      },
      {
        // AP-ACC-03 (US-ACC-022): الگو و سند تکرارشونده.
        id: 'acc-journal-templates',
        labelKey: 'acc:menu.journal_templates',
        path: '/accounting/journal-templates',
        icon: EventRepeatOutlinedIcon,
        permission: 'acc.journal.manual.create',
        feature: 'feature.acc.full_ledger',
        screenId: 'SCR-STAFF-885',
      },
      {
        // AP-ACC-03 (US-ACC-051): مغایرت‌گیری بانکی.
        id: 'acc-reconciliation',
        labelKey: 'acc:menu.reconciliation',
        path: '/accounting/bank-statements',
        icon: RuleFolderOutlinedIcon,
        permission: 'acc.bank.reconcile',
        feature: 'feature.acc.full_ledger',
        screenId: 'SCR-STAFF-888',
      },
      {
        // AP-ACC-03 (US-ACC-061 تا 063): تراز آزمایشی، صورت‌های مالی و مرور حساب.
        id: 'acc-ledger-reports',
        labelKey: 'acc:menu.ledger_reports',
        path: '/accounting/ledger-reports',
        icon: BalanceOutlinedIcon,
        permission: 'acc.report.view',
        feature: 'feature.acc.full_ledger',
        screenId: 'SCR-STAFF-889',
      },
      {
        id: 'acc-control',
        labelKey: 'acc:menu.control',
        path: '/accounting/daily-control',
        icon: VerifiedOutlinedIcon,
        permission: 'acc.journal.view',
        screenId: 'SCR-STAFF-891',
      },
      {
        id: 'acc-errors',
        labelKey: 'acc:menu.errors',
        path: '/accounting/posting-errors',
        icon: ErrorOutlineOutlinedIcon,
        permission: 'acc.posting_errors.manage',
        screenId: 'SCR-STAFF-883',
      },
      {
        // AP-ACC-02: ثبت هزینه ساده (US-ACC-020).
        id: 'acc-expenses',
        labelKey: 'acc:menu.expenses',
        path: '/accounting/expenses',
        icon: ReceiptLongOutlinedIcon,
        permission: 'acc.expense.create',
        screenId: 'SCR-STAFF-884',
      },
      {
        id: 'acc-exports',
        labelKey: 'acc:menu.exports',
        path: '/accounting/exports',
        icon: FileDownloadOutlinedIcon,
        permission: 'acc.export.manage',
        screenId: 'SCR-STAFF-887',
      },
      {
        id: 'acc-reports',
        labelKey: 'acc:menu.reports',
        path: '/accounting/reports',
        icon: InsightsOutlinedIcon,
        permission: 'acc.report.view',
        screenId: 'SCR-STAFF-889',
      },
      {
        id: 'acc-chart',
        labelKey: 'acc:menu.chart',
        path: '/accounting/chart',
        icon: AccountTreeOutlinedIcon,
        permission: 'acc.chart.manage',
        screenId: 'SCR-STAFF-880',
      },
      {
        id: 'acc-mappings',
        labelKey: 'acc:menu.mappings',
        path: '/accounting/mappings',
        icon: DeviceHubOutlinedIcon,
        permission: 'acc.mapping.manage',
        screenId: 'SCR-STAFF-881',
      },
      {
        id: 'acc-fiscal',
        labelKey: 'acc:menu.fiscal',
        path: '/accounting/fiscal',
        icon: EventAvailableOutlinedIcon,
        anyPermission: ['acc.period.manage', 'acc.period.lock'],
        screenId: 'SCR-STAFF-886',
      },
      {
        id: 'acc-banks',
        labelKey: 'acc:menu.banks',
        path: '/accounting/banks',
        icon: AccountBalanceOutlinedIcon,
        permission: 'acc.bank.manage',
        screenId: 'SCR-STAFF-888',
      },
      {
        // AP-ACC-02: گزارش چک‌ها و پیش‌بینی نقدینگی (US-ACC-052؛ همان صفحه SCR-STAFF-888).
        id: 'acc-cheques',
        labelKey: 'acc:menu.cheques',
        path: '/accounting/cheques',
        icon: PaymentsOutlinedIcon,
        permission: 'acc.report.view',
        screenId: 'SCR-STAFF-888',
      },
    ],
  },
  // AP-ENG-01: CRM پایه — صف پیگیری مشاور (SCR-STAFF-962) و سرنخ‌ها (SCR-STAFF-960)؛ مشاوره (SCR-STAFF-961) از سرنخ و صف (routes.tsx).
  {
    id: 'crm',
    labelKey: 'eng:menu.crm',
    path: '/crm',
    children: [
      {
        id: 'eng-queue',
        labelKey: 'eng:menu.queue',
        path: '/crm/queue',
        icon: PlaylistAddCheckOutlinedIcon,
        permission: 'eng.followup.manage',
        feature: 'feature.eng.crm',
        screenId: 'SCR-STAFF-962',
      },
      {
        id: 'eng-leads',
        labelKey: 'eng:menu.leads',
        path: '/crm/leads',
        icon: ContactPhoneOutlinedIcon,
        permission: 'eng.lead.view',
        feature: 'feature.eng.crm',
        screenId: 'SCR-STAFF-960',
      },
      // AP-ENG-02: قواعد پیگیری خودکار (SCR-STAFF-963) و نظرسنجی و بازخورد (SCR-STAFF-967؛ بدون ویژگی CRM — C-AGENT-1566).
      {
        id: 'eng-followup-rules',
        labelKey: 'eng:menu.followup_rules',
        path: '/crm/followup-rules',
        icon: AutoModeOutlinedIcon,
        permission: 'eng.followup.view_all',
        feature: 'feature.eng.crm',
        screenId: 'SCR-STAFF-963',
      },
      {
        id: 'eng-surveys',
        labelKey: 'eng:menu.surveys',
        path: '/crm/surveys',
        icon: PollOutlinedIcon,
        anyPermission: ['eng.feedback.manage', 'eng.survey.manage'],
        screenId: 'SCR-STAFF-967',
      },
    ],
  },
  // AP-CHN-02: میز خدمت — تیکت‌ها (SCR-STAFF-994؛ جزئیات /tickets/:id در routes.tsx)، ثبت دستی تماس (SCR-STAFF-993) و گزارش کانال‌ها (SCR-STAFF-995).
  {
    id: 'service-desk',
    labelKey: 'chn:menu.service_desk',
    path: '/service-desk',
    children: [
      {
        id: 'tickets',
        labelKey: 'chn:menu.tickets',
        path: '/tickets',
        icon: ConfirmationNumberOutlinedIcon,
        permission: 'chn.ticket.create',
        feature: 'feature.chn.ticketing',
        screenId: 'SCR-STAFF-994',
      },
      {
        id: 'calls',
        labelKey: 'chn:menu.calls',
        path: '/calls',
        icon: PhoneInTalkOutlinedIcon,
        anyPermission: ['chn.call.handle', 'chn.call.view_all'],
        screenId: 'SCR-STAFF-993',
      },
      {
        id: 'channel-report',
        labelKey: 'chn:menu.channel_report',
        path: '/reports/channels',
        icon: InsertChartOutlinedIcon,
        permission: 'chn.report.view',
        screenId: 'SCR-STAFF-995',
      },
    ],
  },
  // AP-INS-01: بیمه پایه و تکمیلی (SCR-STAFF-850، 851، 852).
  {
    id: 'insurance',
    labelKey: 'ins:menu.insurance',
    path: '/insurance',
    children: [
      {
        id: 'ins-insurers',
        labelKey: 'ins:menu.insurers',
        path: '/insurance/insurers',
        icon: HealthAndSafetyOutlinedIcon,
        permission: 'ins.insurer.manage',
        screenId: 'SCR-STAFF-850',
      },
      {
        id: 'ins-plans',
        labelKey: 'ins:menu.plans',
        path: '/insurance/plans',
        icon: RuleOutlinedIcon,
        permission: 'ins.plan.manage',
        screenId: 'SCR-STAFF-851',
      },
      {
        id: 'ins-authorizations',
        labelKey: 'ins:menu.authorizations',
        path: '/insurance/authorizations',
        icon: FactCheckOutlinedIcon,
        permission: 'ins.preauth.manage',
        screenId: 'SCR-STAFF-852',
      },
      {
        id: 'ins-claims',
        labelKey: 'ins:menu.claims',
        path: '/insurance/claims',
        icon: ReceiptLongOutlinedIcon,
        permission: 'ins.claim.manage',
        screenId: 'SCR-STAFF-853',
      },
      {
        id: 'ins-deductions',
        labelKey: 'ins:menu.deductions',
        path: '/insurance/deductions',
        icon: RuleOutlinedIcon,
        permission: 'ins.deduction.manage',
        screenId: 'SCR-STAFF-854',
      },
      {
        id: 'ins-remittances',
        labelKey: 'ins:menu.remittances',
        path: '/insurance/remittances',
        icon: PaymentsOutlinedIcon,
        permission: 'ins.remittance.manage',
        screenId: 'SCR-STAFF-855',
      },
      {
        id: 'ins-claim-reports',
        labelKey: 'ins:menu.claim_reports',
        path: '/insurance/claim-reports',
        icon: AssessmentOutlinedIcon,
        permission: 'ins.report.view',
        screenId: 'SCR-STAFF-856',
      },
    ],
  },
  // AP-CMP-01: سهم ارائه‌دهندگان (SCR-STAFF-800، 802، 806).
  {
    id: 'compensation',
    labelKey: 'cmp:menu.compensation',
    path: '/compensation',
    children: [
      {
        id: 'cmp-agreements',
        labelKey: 'cmp:menu.agreements',
        path: '/compensation/agreements',
        icon: HandshakeOutlinedIcon,
        permission: 'cmp.agreement.manage',
        screenId: 'SCR-STAFF-800',
      },
      {
        id: 'cmp-ledger',
        labelKey: 'cmp:menu.ledger',
        path: '/compensation/ledger',
        icon: PercentOutlinedIcon,
        permission: 'cmp.ledger.view',
        screenId: 'SCR-STAFF-802',
      },
      {
        id: 'cmp-report',
        labelKey: 'cmp:menu.report',
        path: '/compensation/report',
        icon: AssessmentOutlinedIcon,
        permission: 'cmp.report.view',
        screenId: 'SCR-STAFF-806',
      },
      // AP-CMP-02: شبیه‌ساز، معرفان، صورت‌وضعیت، تسویه و پرتال ارائه‌دهنده (SCR-STAFF-801، 803، 804، 805، 807).
      {
        id: 'cmp-simulator',
        labelKey: 'cmp:menu.simulator',
        path: '/compensation/simulator',
        icon: CalculateOutlinedIcon,
        permission: 'cmp.agreement.manage',
        screenId: 'SCR-STAFF-801',
      },
      {
        id: 'cmp-referrers',
        labelKey: 'cmp:menu.referrers',
        path: '/compensation/referrers',
        icon: GroupAddOutlinedIcon,
        permission: 'cmp.referrer.manage',
        screenId: 'SCR-STAFF-803',
      },
      {
        id: 'cmp-statements',
        labelKey: 'cmp:menu.statements',
        path: '/compensation/statements',
        icon: ReceiptLongOutlinedIcon,
        permission: 'cmp.statement.manage',
        screenId: 'SCR-STAFF-804',
      },
      {
        id: 'cmp-payouts',
        labelKey: 'cmp:menu.payouts',
        path: '/compensation/payouts',
        icon: AccountBalanceWalletOutlinedIcon,
        permission: 'cmp.payout.manage',
        feature: 'feature.cmp.payouts',
        screenId: 'SCR-STAFF-805',
      },
      {
        id: 'cmp-portal',
        labelKey: 'cmp:menu.portal',
        path: '/compensation/portal',
        icon: BadgeOutlinedIcon,
        permission: 'cmp.share.view_own',
        feature: 'feature.cmp.provider_portal',
        screenId: 'SCR-STAFF-807',
      },
    ],
  },
  // AP-INV-01: کالا، بچ و تأمین‌کنندگان (SCR-STAFF-870، 877؛ فاز 1 بدون موجودی — C11).
  {
    id: 'inventory',
    labelKey: 'inv:menu.inventory',
    path: '/inventory',
    children: [
      {
        id: 'inv-items',
        labelKey: 'inv:menu.items',
        path: '/inventory/items',
        icon: Inventory2OutlinedIcon,
        permission: 'inv.item.view',
        screenId: 'SCR-STAFF-870',
      },
      {
        id: 'inv-suppliers',
        labelKey: 'inv:menu.suppliers',
        path: '/inventory/suppliers',
        icon: LocalShippingOutlinedIcon,
        permission: 'inv.supplier.manage',
        screenId: 'SCR-STAFF-877',
      },
      // AP-INV-02: موجودی و گردش (فاز 2؛ ماژول انبار — feature.inv.inventory).
      {
        id: 'inv-stock',
        labelKey: 'inv:menu.stock',
        path: '/inventory/stock',
        icon: WarehouseOutlinedIcon,
        permission: 'inv.stock.view',
        feature: 'feature.inv.inventory',
        screenId: 'SCR-STAFF-871',
      },
      {
        id: 'inv-documents',
        labelKey: 'inv:menu.documents',
        path: '/inventory/documents',
        icon: SwapHorizOutlinedIcon,
        permission: 'inv.stock.view',
        feature: 'feature.inv.inventory',
        screenId: 'SCR-STAFF-872',
      },
      {
        id: 'inv-open-containers',
        labelKey: 'inv:menu.open_containers',
        path: '/inventory/open-containers',
        icon: ScienceOutlinedIcon,
        permission: 'inv.stock.view',
        feature: 'feature.inv.inventory',
        screenId: 'SCR-STAFF-873',
      },
      {
        id: 'inv-alerts',
        labelKey: 'inv:menu.alerts',
        path: '/inventory/alerts',
        icon: NotificationsActiveOutlinedIcon,
        permission: 'inv.stock.view',
        feature: 'feature.inv.inventory',
        screenId: 'SCR-STAFF-874',
      },
      {
        id: 'inv-stocktakes',
        labelKey: 'inv:menu.stocktakes',
        path: '/inventory/stocktakes',
        icon: FactCheckOutlinedIcon,
        permission: 'inv.stocktake.manage',
        feature: 'feature.inv.inventory',
        screenId: 'SCR-STAFF-875',
      },
      // AP-INV-03: خرید (درخواست، سفارش، رسید از سفارش، فاکتور، پیشنهاد سفارش).
      {
        id: 'inv-purchasing',
        labelKey: 'inv:menu.purchasing',
        path: '/inventory/purchasing',
        icon: ShoppingCartOutlinedIcon,
        anyPermission: [
          'inv.purchase_request.create',
          'inv.purchase_request.approve',
          'inv.po.manage',
          'inv.supplier_invoice.manage',
        ],
        feature: 'feature.inv.inventory',
        screenId: 'SCR-STAFF-876',
      },
      {
        id: 'inv-reports',
        labelKey: 'inv:menu.reports',
        path: '/inventory/reports',
        icon: AssessmentOutlinedIcon,
        permission: 'inv.report.view',
        feature: 'feature.inv.inventory',
        screenId: 'SCR-STAFF-878',
      },
      {
        id: 'inv-settings',
        labelKey: 'inv:menu.settings',
        path: '/inventory/settings',
        icon: TuneOutlinedIcon,
        permission: 'inv.settings.manage',
        feature: 'feature.inv.inventory',
        screenId: 'SCR-STAFF-879',
      },
    ],
  },
  {
    id: 'settings',
    labelKey: 'plt:menu.settings',
    path: '/settings',
    children: [
      {
        id: 'center',
        labelKey: 'plt:menu.center',
        path: '/settings/center',
        icon: BusinessOutlinedIcon,
        // مشاهده با view و ویرایش با manage (C-AGENT-157، C-AGENT-205).
        anyPermission: ['plt.tenant.profile.manage', 'plt.tenant.profile.view'],
        screenId: 'SCR-STAFF-902',
      },
      {
        id: 'branches',
        labelKey: 'plt:menu.branches',
        path: '/settings/branches',
        icon: ApartmentOutlinedIcon,
        anyPermission: ['plt.branch.manage', 'plt.branch.view'],
        screenId: 'SCR-STAFF-903',
      },
      {
        id: 'general',
        labelKey: 'plt:menu.general',
        path: '/settings/general',
        icon: TuneOutlinedIcon,
        permission: 'plt.tenant.profile.manage',
        screenId: 'SCR-STAFF-906',
      },
      {
        id: 'holiday-management',
        labelKey: 'plt:menu.holiday_board',
        path: '/settings/holidays',
        icon: EventRepeatOutlinedIcon,
        anyPermission: ['plt.branch.view', 'plt.settings.manage'],
        screenId: 'SCR-STAFF-911',
      },
      // AP-PLT-05: چک‌لیست و Go-Live، پروفایل عمومی و دسترسی‌های پشتیبانی.
      {
        id: 'checklist',
        labelKey: 'plt:menu.checklist',
        path: '/settings/checklist',
        icon: ChecklistOutlinedIcon,
        permission: 'plt.onboarding.manage',
        screenId: 'SCR-STAFF-901',
      },
      {
        id: 'public-profile',
        labelKey: 'plt:menu.public_profile',
        path: '/settings/public-profile',
        icon: PublicOutlinedIcon,
        anyPermission: ['plt.settings.manage', 'plt.tenant.profile.view'],
        screenId: 'SCR-STAFF-907',
      },
      {
        id: 'support-access',
        labelKey: 'plt:menu.support_access',
        path: '/settings/support-access',
        icon: SupportAgentOutlinedIcon,
        permission: 'plt.support_access.approve',
        screenId: 'SCR-STAFF-908',
      },
      // AP-PLT-08: نصب On-prem (لایسنس، بسته داده مرجع)؛ فقط دارنده onprem.license.install آن را می‌بیند و در SaaS
      // هیچ نقشی این Permission را ندارد (PRD-PLT §10.3).
      {
        id: 'installation',
        labelKey: 'plt:menu.installation',
        path: '/settings/installation',
        icon: VpnKeyOutlinedIcon,
        permission: 'onprem.license.install',
        screenId: 'SCR-STAFF-910',
      },
      // AP-CHN-01: پرتال، صفحه عمومی، صفحه پزشکان و ویجت (SCR-STAFF-990) و تعدیل نظرات (SCR-STAFF-991).
      {
        id: 'channels',
        labelKey: 'chn:menu.channels',
        path: '/settings/channels',
        icon: WebOutlinedIcon,
        anyPermission: ['chn.portal.manage', 'chn.public_page.manage'],
        screenId: 'SCR-STAFF-990',
      },
      {
        id: 'provider-presence',
        labelKey: 'chn:menu.provider_presence',
        path: '/settings/provider-presence',
        icon: WebOutlinedIcon,
        permission: 'chn.public_page.manage',
        screenId: 'SCR-STAFF-996',
      },
      {
        id: 'my-provider-profile',
        labelKey: 'chn:menu.my_provider_profile',
        path: '/settings/my-provider-profile',
        icon: WebOutlinedIcon,
        permission: 'chn.provider_profile.manage_own',
        screenId: 'SCR-STAFF-997',
      },
      {
        id: 'reviews',
        labelKey: 'chn:menu.reviews',
        path: '/settings/reviews',
        icon: RateReviewOutlinedIcon,
        permission: 'chn.review.moderate',
        screenId: 'SCR-STAFF-991',
      },
      // AP-CHN-02: انواع و دسته‌های تیکت و ساعات کاری SLA (US-CHN-040).
      {
        id: 'ticket-settings',
        labelKey: 'chn:menu.ticket_settings',
        path: '/settings/tickets',
        icon: SupportAgentOutlinedIcon,
        permission: 'chn.ticket.manage',
        feature: 'feature.chn.ticketing',
        screenId: 'SCR-STAFF-994',
      },
      // AP-CAT-01: خدمات و مالی (IA §6).
      {
        id: 'services',
        labelKey: 'cat:menu.services',
        path: '/settings/services',
        icon: MedicalServicesOutlinedIcon,
        permission: 'cat.service.view',
        screenId: 'SCR-STAFF-200',
      },
      {
        id: 'prices',
        labelKey: 'cat:menu.prices',
        path: '/settings/prices',
        icon: SellOutlinedIcon,
        permission: 'cat.price.view',
        screenId: 'SCR-STAFF-202',
      },
      // AP-CAT-02: تغییر گروهی قیمت (US-CAT-026).
      {
        id: 'bulk-prices',
        labelKey: 'cat:menu.bulk_prices',
        path: '/settings/prices/bulk',
        icon: PercentOutlinedIcon,
        permission: 'cat.price.bulk_change',
        screenId: 'SCR-STAFF-203',
      },
      // AP-CAT-03: پکیج و عضویت، تخفیف و کوپن، شبیه‌ساز قیمت.
      {
        id: 'packages',
        labelKey: 'cat:menu.packages',
        path: '/settings/packages',
        icon: Inventory2OutlinedIcon,
        permission: 'cat.price.view',
        screenId: 'SCR-STAFF-206',
      },
      {
        id: 'discounts',
        labelKey: 'cat:menu.discounts',
        path: '/settings/discounts',
        icon: LocalOfferOutlinedIcon,
        permission: 'cat.price.view',
        screenId: 'SCR-STAFF-207',
      },
      {
        id: 'price-simulator',
        labelKey: 'cat:menu.simulator',
        path: '/settings/prices/simulator',
        icon: CalculateOutlinedIcon,
        permission: 'cat.price.simulate',
        screenId: 'SCR-STAFF-208',
      },
      // AP-CAT-04: تعرفه مصوب و قرارداد سازمانی (US-CAT-030 تا 033، 040، 041).
      {
        id: 'tariff-book',
        labelKey: 'cat:menu.tariff',
        path: '/settings/prices/tariff',
        icon: RuleOutlinedIcon,
        permission: 'cat.price.view',
        screenId: 'SCR-STAFF-204',
      },
      {
        id: 'organization-contracts',
        labelKey: 'cat:menu.contracts',
        path: '/settings/contracts',
        icon: HandshakeOutlinedIcon,
        permission: 'cat.price.view',
        screenId: 'SCR-STAFF-205',
      },
      // AP-BIL-01: تنظیمات مالی (گردکردن، بستن خودکار، شماره‌گذاری).
      {
        id: 'billing-settings',
        labelKey: 'bil:menu.settings',
        path: '/settings/billing',
        icon: RequestQuoteOutlinedIcon,
        permission: 'bil.settings.manage',
        screenId: 'SCR-STAFF-415',
      },
      {
        id: 'patient-settings',
        labelKey: 'pat:menu.settings',
        path: '/settings/patients',
        icon: PersonSearchOutlinedIcon,
        permission: 'pat.settings.manage',
        screenId: 'SCR-STAFF-108',
      },
      // AP-SCH-01: برنامه کاری ارائه‌دهندگان، استثناها و افق رزرو.
      {
        id: 'schedules',
        labelKey: 'sch:menu.schedules',
        path: '/settings/schedules',
        icon: EventNoteOutlinedIcon,
        anyPermission: ['sch.schedule.manage', 'sch.schedule.view'],
        screenId: 'SCR-STAFF-304',
      },
      // AP-SCH-02: سیاست‌های نوبت‌دهی و محدودیت غیبت.
      {
        id: 'booking-policies',
        labelKey: 'sch:menu.policies',
        path: '/settings/booking-policies',
        icon: EventAvailableOutlinedIcon,
        permission: 'sch.policy.manage',
        screenId: 'SCR-STAFF-308',
      },
      // AP-SCH-05: قانون‌های پذیرش.
      {
        id: 'admission-rules',
        labelKey: 'sch:menu.admission_rules',
        path: '/settings/admission-rules',
        icon: RuleOutlinedIcon,
        permission: 'sch.admission_rule.manage',
        screenId: 'SCR-STAFF-313',
      },
      // AP-MSG-01: کانال‌ها، قالب‌ها و قواعد اطلاع‌رسانی.
      {
        id: 'messaging-channels',
        labelKey: 'msg:menu.channels',
        path: '/settings/messaging/channels',
        icon: SmsOutlinedIcon,
        permission: 'msg.channel.manage',
        screenId: 'SCR-STAFF-950',
      },
      {
        id: 'messaging-templates',
        labelKey: 'msg:menu.templates',
        path: '/settings/messaging/templates',
        icon: ArticleOutlinedIcon,
        permission: 'msg.template.manage',
        screenId: 'SCR-STAFF-951',
      },
      {
        id: 'messaging-rules',
        labelKey: 'msg:menu.rules',
        path: '/settings/messaging/rules',
        icon: RuleOutlinedIcon,
        permission: 'msg.rule.manage',
        screenId: 'SCR-STAFF-952',
      },
      // AP-DOC-01: فرم‌ها، رضایت‌نامه‌ها، قالب‌های چاپ و تنظیمات اسناد (IA §6 «بالینی» و «مرکز»).
      {
        id: 'form-templates',
        labelKey: 'doc:menu.forms',
        path: '/settings/forms',
        icon: DynamicFormOutlinedIcon,
        permission: 'doc.form_template.manage',
        screenId: 'SCR-STAFF-601',
      },
      {
        id: 'form-studio',
        labelKey: 'doc:studio.menu',
        path: '/settings/form-studio',
        icon: DynamicFormOutlinedIcon,
        permission: 'doc.form_template.manage',
        screenId: 'SCR-STAFF-615',
      },
      {
        id: 'shared-fields',
        labelKey: 'doc:sharedFields.menu',
        path: '/settings/shared-fields',
        icon: DynamicFormOutlinedIcon,
        permission: 'doc.shared_field.manage',
        screenId: 'SCR-STAFF-616',
      },
      {
        id: 'consent-templates',
        labelKey: 'doc:menu.consents',
        path: '/settings/consents',
        icon: DrawOutlinedIcon,
        permission: 'doc.consent_template.manage',
        screenId: 'SCR-STAFF-603',
      },
      {
        id: 'print-templates',
        labelKey: 'doc:menu.print',
        path: '/settings/print-templates',
        icon: PrintOutlinedIcon,
        permission: 'doc.print_template.manage',
        screenId: 'SCR-STAFF-605',
      },
      {
        id: 'document-settings',
        labelKey: 'doc:menu.settings',
        path: '/settings/documents',
        icon: FolderOpenOutlinedIcon,
        permission: 'doc.settings.manage',
        screenId: 'SCR-STAFF-608',
      },
      // AP-DOC-03: کلاس نگهداری، نگهداشت قانونی و امحا (SCR-STAFF-607).
      {
        id: 'document-retention',
        labelKey: 'doc:menu.retention',
        path: '/settings/documents/retention',
        icon: DeleteSweepOutlinedIcon,
        anyPermission: ['doc.retention.manage', 'doc.legal_hold.manage', 'doc.retention.destroy'],
        screenId: 'SCR-STAFF-607',
      },
      // AP-MED-01: فهرست دارو، نسخه‌های آماده، پنل‌ها و مراکز طرف قرارداد (SCR-STAFF-706).
      {
        id: 'med-settings',
        labelKey: 'med:menu.settings',
        path: '/settings/medical-orders',
        icon: MedicationOutlinedIcon,
        anyPermission: ['med.drug_list.manage', 'med.order_panel.manage', 'med.partner.manage'],
        screenId: 'SCR-STAFF-706',
      },
      // AP-CLN-01: قالب‌ها، عبارات سریع، فهرست تشخیص و قواعد منع مصرف (IA §5 «بالینی»).
      {
        id: 'clinical-settings',
        labelKey: 'cln:menu.settings',
        path: '/settings/clinical',
        icon: MedicalServicesOutlinedIcon,
        permission: 'cln.template.manage',
        screenId: 'SCR-STAFF-508',
      },
      {
        id: 'staff',
        labelKey: 'iam:menu.staff',
        path: '/settings/staff',
        icon: GroupsOutlinedIcon,
        permission: 'iam.member.view',
        screenId: 'SCR-STAFF-920',
      },
      // ORG (AP-ORG-01؛ IA §6 «سازمان و منابع»): مشاهده با org.resource.view و نوشتن با manage (C-AGENT-254).
      {
        id: 'departments',
        labelKey: 'org:menu.departments',
        path: '/settings/departments',
        icon: AccountTreeOutlinedIcon,
        anyPermission: ['org.department.manage', 'org.resource.view'],
        screenId: 'SCR-STAFF-930',
      },
      {
        id: 'rooms',
        labelKey: 'org:menu.rooms',
        path: '/settings/rooms',
        icon: MeetingRoomOutlinedIcon,
        anyPermission: ['org.room.manage', 'org.resource.view'],
        screenId: 'SCR-STAFF-931',
      },
      {
        id: 'resource-tags',
        labelKey: 'org:menu.resource_tags',
        path: '/settings/resource-tags',
        icon: LocalOfferOutlinedIcon,
        anyPermission: ['org.room.manage', 'org.resource.view'],
        screenId: 'SCR-STAFF-932',
      },
      // AP-ORG-02: انواع دستگاه (SCR-STAFF-932)، دستگاه‌ها (935؛ شناسنامه 936 در routes.tsx) و تقویم مسدودسازی (933).
      {
        id: 'device-types',
        labelKey: 'org:menu.device_types',
        path: '/settings/device-types',
        icon: PrecisionManufacturingOutlinedIcon,
        anyPermission: ['org.device.manage', 'org.device.view'],
        screenId: 'SCR-STAFF-932',
      },
      {
        id: 'devices',
        labelKey: 'org:menu.devices',
        path: '/settings/devices',
        icon: DevicesOtherOutlinedIcon,
        anyPermission: ['org.device.manage', 'org.device.view'],
        screenId: 'SCR-STAFF-935',
      },
      {
        id: 'resource-blocks',
        labelKey: 'org:menu.resource_blocks',
        path: '/settings/resource-blocks',
        icon: EventBusyOutlinedIcon,
        anyPermission: ['org.resource_block.manage', 'org.resource.view'],
        screenId: 'SCR-STAFF-933',
      },
      {
        id: 'roles',
        labelKey: 'iam:menu.roles',
        path: '/settings/roles',
        icon: AdminPanelSettingsOutlinedIcon,
        permission: 'iam.member.view',
        screenId: 'SCR-STAFF-922',
      },
      // AP-IAM-05: حساب‌های دستگاه (تبلت، نمایشگر صف، پنل فراخوان، کیوسک — US-IAM-053).
      {
        id: 'device-accounts',
        labelKey: 'iam:menu.device_accounts',
        path: '/settings/device-accounts',
        icon: TabletAndroidOutlinedIcon,
        permission: 'iam.device_account.manage',
        screenId: 'SCR-STAFF-924',
      },
      // AP-IAM-03: سیاست‌های دسترسی (الزام 2FA نقش‌ها).
      {
        id: 'access-policies',
        labelKey: 'iam:menu.access_policies',
        path: '/settings/access-policies',
        icon: PolicyOutlinedIcon,
        permission: 'iam.role.manage',
        screenId: 'SCR-STAFF-923',
      },
      {
        id: 'configuration',
        labelKey: 'cfg:menu.all_settings',
        path: '/settings/configuration',
        icon: SettingsSuggestOutlinedIcon,
        permission: 'cfg.settings.view',
        screenId: 'SCR-STAFF-1200',
      },
      // AP-PLT-05: ماژول‌ها و فیلدهای سفارشی (CFG).
      {
        id: 'modules',
        labelKey: 'cfg:menu.modules',
        path: '/settings/modules',
        icon: ExtensionOutlinedIcon,
        permission: 'cfg.settings.view',
        screenId: 'SCR-STAFF-1201',
      },
      {
        id: 'custom-fields',
        labelKey: 'cfg:menu.custom_fields',
        path: '/settings/custom-fields',
        icon: TextFieldsOutlinedIcon,
        permission: 'cfg.settings.view',
        screenId: 'SCR-STAFF-1202',
      },
      // AP-CFG-01: بسته‌های تخصصی و بازبینی محتوای نمونه (FLOW-16)؛ پارامترها و قواعد بالینی.
      {
        id: 'specialty-packs',
        labelKey: 'cfg:menu.specialty_packs',
        path: '/settings/specialty-packs',
        icon: CategoryOutlinedIcon,
        anyPermission: ['plt.onboarding.manage', 'cfg.sample_content.review'],
        screenId: 'SCR-STAFF-1203',
      },
      {
        id: 'parameters-rules',
        labelKey: 'cfg:menu.parameters_rules',
        path: '/settings/parameters-rules',
        icon: TuneOutlinedIcon,
        anyPermission: ['cfg.parameters.manage', 'cfg.clinical_rules.manage'],
        screenId: 'SCR-STAFF-1204',
      },
      {
        id: 'calculator-library',
        labelKey: 'cfg:calculators.menu',
        path: '/settings/calculators',
        icon: TuneOutlinedIcon,
        permission: 'doc.form_template.manage',
        screenId: 'SCR-STAFF-1206',
      },
      {
        id: 'integrations',
        labelKey: 'int:menu.integrations',
        path: '/settings/integrations',
        icon: CableOutlinedIcon,
        permission: 'int.endpoint.manage',
        screenId: 'SCR-STAFF-1000',
      },
      // AP-INT-02: سلامت اتصال‌ها و Call Log، و فراخوان‌های ناموفق (Dead Letter).
      {
        id: 'integration-health',
        labelKey: 'int:menu.health',
        path: '/settings/integrations/health',
        icon: MonitorHeartOutlinedIcon,
        permission: 'int.log.view',
        screenId: 'SCR-STAFF-1001',
      },
      {
        id: 'dead-letters',
        labelKey: 'int:menu.dead_letters',
        path: '/settings/integrations/dead-letters',
        icon: ReportGmailerrorredOutlinedIcon,
        permission: 'int.dead_letter.manage',
        screenId: 'SCR-STAFF-1002',
      },
      // AP-SCH-03: کانال‌های خارجی نوبت‌دهی (مارکت‌پلیس) — اتصال به Endpoint INT، نگاشت، سهمیه و همگام‌سازی (US-SCH-080 تا 083).
      {
        id: 'booking-channels',
        labelKey: 'sch:menu.booking_channels',
        path: '/settings/integrations/booking-channels',
        icon: StorefrontOutlinedIcon,
        permission: 'sch.channel.manage',
        feature: 'feature.sch.marketplace_sync',
        screenId: 'SCR-STAFF-311',
      },
      // AP-MED-03: ظرفیت و نوبت ارجاعی سیب (SCR-STAFF-317، 318؛ US-SCH-132 تا 134) — الزام حاکمیتی، پس بی‌Feature.
      {
        id: 'sch-referral-capacity',
        labelKey: 'sch:menu.referral_capacity',
        path: '/settings/integrations/referral-capacity',
        icon: ForwardToInboxOutlinedIcon,
        permission: 'sch.referral_capacity.send',
        screenId: 'SCR-STAFF-317',
      },
      // AP-MED-03: اتصال ارجاع ملی شعبه با PID و نمای همگام‌سازی (SCR-STAFF-1005؛ US-INT-100، 102).
      {
        id: 'int-national-referral',
        labelKey: 'int:menu.national_referral',
        path: '/settings/integrations/national-referral',
        icon: CloudSyncOutlinedIcon,
        permission: 'int.endpoint.manage',
        screenId: 'SCR-STAFF-1005',
      },
      // AP-INT-03: عامل‌های محلی، تجهیزات و نگاشت نقش ایستگاه کاری (US-INT-060 تا 064).
      // AP-INT-10 (US-INT-112، 116): اعتبارنامه بیمه‌گر هر کاربر و اتصال شعبه به مرکز سیام.
      {
        id: 'insurer-credentials',
        labelKey: 'int:menu.insurer_credentials',
        path: '/settings/integrations/insurer-credentials',
        icon: BadgeOutlinedIcon,
        permission: 'int.credential.manage_own',
        screenId: 'SCR-STAFF-1006',
      },
      {
        id: 'branch-insurer-sites',
        labelKey: 'int:menu.insurer_sites',
        path: '/settings/integrations/insurer-sites',
        icon: LocalHospitalOutlinedIcon,
        permission: 'int.endpoint.manage',
        screenId: 'SCR-STAFF-1009',
      },
      {
        id: 'local-agents',
        labelKey: 'int:menu.agents',
        path: '/settings/integrations/agents',
        icon: ComputerOutlinedIcon,
        permission: 'int.agent.manage',
        screenId: 'SCR-STAFF-1003',
      },
      {
        id: 'api-clients',
        labelKey: 'int:menu.api_clients',
        path: '/settings/api-clients',
        icon: ApiOutlinedIcon,
        permission: 'int.api_client.manage',
        feature: 'feature.int.public_api',
        screenId: 'SCR-STAFF-1004',
      },
      // AP-PLT-03: ورود داده (IA §6 «داده»).
      {
        id: 'import',
        labelKey: 'plt:menu.import',
        path: '/settings/import',
        icon: UploadFileOutlinedIcon,
        permission: 'plt.import.run',
        screenId: 'SCR-STAFF-905',
      },
      {
        id: 'audit',
        labelKey: 'iam:menu.audit',
        path: '/settings/audit',
        icon: HistoryOutlinedIcon,
        anyPermission: ['iam.audit.view', 'iam.security_events.view'],
        screenId: 'SCR-STAFF-925',
      },
      // AP-IAM-04: صف بازبینی دسترسی اضطراری (US-IAM-042).
      {
        id: 'break-glass-reviews',
        labelKey: 'iam:menu.break_glass_reviews',
        path: '/settings/break-glass-reviews',
        icon: GppMaybeOutlinedIcon,
        permission: 'iam.break_glass.review',
        screenId: 'SCR-STAFF-927',
      },
      {
        id: 'subscription',
        labelKey: 'plt:menu.subscription',
        path: SUBSCRIPTION_PATH,
        icon: CardMembershipOutlinedIcon,
        permission: 'plt.subscription.view',
        screenId: 'SCR-STAFF-904',
      },
      // AP-PLT-07: خاتمه اشتراک، خروجی کامل داده و انتقال مالکیت (فقط مالک).
      {
        id: 'termination',
        labelKey: 'plt:menu.termination',
        path: '/settings/termination',
        icon: ExitToAppOutlinedIcon,
        anyPermission: ['plt.tenant.terminate', 'plt.tenant.export', 'plt.tenant.transfer_ownership'],
        screenId: 'SCR-STAFF-909',
      },
    ],
  },
];

/**
 * مسیرهای عمومی بدون ورود (AP-IAM-02): پذیرش دعوت و تعیین رمز مالک، بازیابی رمز؛ AP-DOC-01: لینک فرم پیش از مراجعه (/f)، امضای از راه
 * دور (/s) و سند اشتراکی (/d) — SCR-PUBLIC-010/011/012 با OTP خودشان؛ AP-PLT-07: ثبت‌نام (/signup)، بازگشت پرداخت اشتراک، پذیرش مالکیت و دانلود
 * خروجی (C-AGENT-1171).
 */
export function isPublicPath(pathname: string): boolean {
  // C-AGENT-1122: همه مسیرهای عمومی routes.tsx (پرداخت لینک، تأیید QR نسخه، حالت دستگاه تبلت، نظرسنجی AP-ENG-02) بدون ورود کارکنان.
  return (
    /^\/(invitations|invite|f|s|d|pay|v|survey|subscription-payment|ownership|exports)\/[^/]+\/?$/.test(pathname) ||
    /^\/(recover|device|signup)\/?$/.test(pathname)
  );
}

/** همه آیتم‌های برگ (برای ساخت Routeهای placeholder). */
export function leafItems(items: readonly StaffMenuItem[] = staffMenu): StaffMenuItem[] {
  return items.flatMap((item) => (item.children ? leafItems(item.children) : [item]));
}
